"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createCSSRuleFromTheme: function() {
        return _FluentProvider.createCSSRuleFromTheme;
    },
    fluentProviderClassNames: function() {
        return _FluentProvider.fluentProviderClassNames;
    },
    FluentProvider: function() {
        return _FluentProvider.FluentProvider;
    },
    renderFluentProvider_unstable: function() {
        return _FluentProvider.renderFluentProvider_unstable;
    },
    useFluentProviderContextValues_unstable: function() {
        return _FluentProvider.useFluentProviderContextValues_unstable;
    },
    useFluentProvider_unstable: function() {
        return _FluentProvider.useFluentProvider_unstable;
    },
    useFluentProviderStyles_unstable: function() {
        return _FluentProvider.useFluentProviderStyles_unstable;
    },
    useFluentProviderThemeStyleTag: function() {
        return _FluentProvider.useFluentProviderThemeStyleTag;
    }
});
const _FluentProvider = require("./FluentProvider");
